import { Input } from 'components/atoms';
import { useFormikField } from 'hooks/useFormikField';
import { useEffect, useState } from 'react';
import { GroupBase } from 'react-select';
import {
  ISelectInputProps,
  ISelectOption,
} from 'types/components/inputs/input.interface';

const SelectInputForm = <T,>({
  name,
  isError = true,
  onChange,
  ...props
}: ISelectInputProps<T>) => {
  const [field, { error, value, status }, { setValue }] = useFormikField<any>(
    name ?? ''
  );

  const [selectValue, setSelectValue] = useState<ISelectOption | undefined>(
    undefined
  );

  const isValidValue = (value: any) => value != -1 && value !== '';

  useEffect(() => {
    const flattedOptions = props.options
      ?.map(option => {
        const groupOrOption = option as GroupBase<ISelectOption> &
          ISelectOption;
        return !!groupOrOption.options ? groupOrOption.options : groupOrOption;
      })
      .flat();

    const initialOption = flattedOptions?.find(
      option => option.value === field.value
    );

    setSelectValue(
      isValidValue(value)
        ? initialOption ??
            (props.value
              ? (props.value as ISelectOption)
              : { value: value, label: value })
        : undefined
    );
  }, [value, selectValue?.value, undefined, props.options]);

  return (
    <Input.Select
      displayMode={
        props.displayMode === undefined
          ? status?.displayMode
          : props.displayMode
      }
      isLoading={status?.isLoading}
      {...props}
      {...field}
      onChange={(newValue, actionMeta) => {
        if (newValue) {
          setValue(newValue.value);
          setSelectValue(newValue);
        }
        onChange && onChange(newValue, actionMeta);
      }}
      inputId={name}
      value={selectValue}
      error={error}
      // isSearchable={false}
    />
  );
};

export default SelectInputForm;
